<div *ngIf="metadata" class="gl-dashboard__toolbar full-width">
  <div class="gl-dashboard__lastModified">
    <span
      >{{ 'reports.lastDataUpdate' | translate }} <b>{{ metadata.lastUpdate | date : 'shortDate' }}</b>
      {{ metadata.lastUpdate | date : 'HH:mm' }}</span
    >
    <gl-tooltip posbottom [text]="'reports.lastDataUpdateMessage' | translate"></gl-tooltip>
  </div>
</div>
<div class="dashboard-widget-container">
  <lms-widget-container [widget]="widget" *ngFor="let widget of widgets"></lms-widget-container>
</div>
